module.exports = __webpack_public_path__ + "img/Img0077.592442cc.jpg";